// 登录、重置密码、注册
import request from '@/utils/request';
import { encryptString, getDeviceId } from '@/utils';

const serverUrl = process.env.VUE_APP_BASE_API;
const paymentUrl = process.env.VUE_APP_PAYMENT_BASE_API;

const login = {
  // 登录
  async userLogin(data) {
    const username = (data.username && data.username.toLowerCase()) || '';
    const password = await encryptString(data.password);
    return request({
      url: `${serverUrl}/visa/latam/login/index`,
      method: 'POST',
      data: { ...data, username, password },
    });
  },

  // 退出登录
  userLogout(data) {
    return request({
      url: `${serverUrl}/visa/latam/login/logout`,
      method: 'POST',
      data,
    });
  },

  // 获取可用区域
  getAvailable(data) {
    return request({
      url: `${serverUrl}/visa/latam/region/available`,
      method: 'POST',
      // headers: {
      //   'Content-Type': 'application/json',
      // },
      data,
    });
  },

  // signup-step1-visa信用卡校验（visa-vces-api服务接口）
  vcesVerify(data) {
    return request({
      url: `${paymentUrl}/pan/api/visa/vces/validation`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    });
  },

  // 获取支付渠道
  getPaymentChannel(data) {
    return request({
      url: `${serverUrl}/visa/latam/checkCard/getPaymentChannel`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    });
  },

  // signup-step1-卡vces\ingenico 0元校验
  checkCardInfo(data) {
    return request({
      // url: `${serverUrl}/visa/card/vces/ingenico/v3/checkCard`,
      url: `${serverUrl}/visa/latam/checkCard/v1`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      // 接口要求必须携带 deviceId（后端用于设备维度风控），统一在此补齐，避免调用方遗漏
      data: { ...data, deviceId: data?.deviceId || getDeviceId() },
    });
  },

  ingenico3DSNotify(data) {
    return request({
      url: `${serverUrl}/visa/latam/checkCard/threeDSNotify`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      // 3DS 回跳属于同一次 0 元校验流程，deviceId 必须与 checkCard/v1 保持一致
      data: { ...data, deviceId: data?.deviceId || getDeviceId() },
    });
  },

  // signup-step1-判断信用卡是否被注册
  checkCardNoStatus(data) {
    return request({
      url: `${serverUrl}/visa/card/vces/checkRegisterStatus`,
      method: 'POST',
      data,
    });
  },

  // signup-step2-用户注册信息校验
  checkUserInfo(data) {
    return request({
      url: `${serverUrl}/visa/card/vces/info/check`,
      method: 'POST',
      data,
    });
  },

  // 注册发送短信接口
  sendRegisterAuthCode(data) {
    return request({
      url: `${serverUrl}/visa/latam/otp/sendRegisterAuthCodeV2`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // 验证注册验证码接口
  checkRegisterAuthCode(data) {
    return request({
      url: `${serverUrl}/visa/latam/otp/checkRegisterAuthCodeV2`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // 用户注册接口-v2
  async registerMFA(data) {
    const password = await encryptString(data.password);
    return request({
      url: `${serverUrl}/visa/card/vces/v2/register`,
      method: 'POST',
      data: { ...data, password, device: 'web' },
    });
  },

  // signup-step3-信用卡注册保存
  async register(data) {
    const password = await encryptString(data.password);
    return request({
      url: `${serverUrl}/visa/card/vces/ingenico/register`,
      method: 'POST',
      headers: {
        'Accept-Language': data.lang,
      },
      data: { ...data, password, device: 'web' },
    });
  },

  // signup-step3-创建session
  createSession(data) {
    return request({
      url: `${serverUrl}/visa/latam/payment/ingenico/session`,
      method: 'POST',
      data,
    });
  },

  // 发送验证码
  sendCode(data) {
    return request({
      url: `${serverUrl}/visa/latam/login/findPassword`,
      method: 'POST',
      data,
    });
  },

  // 校验验证码是否一致
  checkCode(data) {
    return request({
      url: `${serverUrl}/visa/latam/login/findPasswordCheck`,
      method: 'POST',
      data,
    });
  },

  // 保存新密码
  async saveNewPassword(data) {
    const password = await encryptString(data.password);
    return request({
      url: `${serverUrl}/visa/latam/login/findPasswordSave`,
      method: 'POST',
      data: { ...data, password },
    });
  },

  // 判断链接是否有效
  async resetPasswordEmailExpire(data) {
    return request({
      url: `${serverUrl}/visa/latam/login/portal/resetPasswordEmailExpire?token=${data.token}`,
      method: 'GET',
      headers: {
        'X-Visa-Region': data.region,
        region: data.region,
      },
    });
  },

  // portal重置密码
  async resetPortalPassword(data) {
    const password = await encryptString(data.password);
    return request({
      url: `${serverUrl}/visa/latam/login/portal/resetPassword`,
      method: 'POST',
      headers: {
        'X-Visa-Region': data.region,
        region: data.region,
      },
      data: { ...data, password },
    });
  },

  // 获取龙腾卡信息
  getDragonCard(data) {
    return request({
      url: `${serverUrl}/visa/latam/card/default`,
      method: 'POST',
      data,
    });
  },

  // 获取全球国家列表
  areaCodeList(data) {
    return request({
      url: `${serverUrl}/visa/latam/area/getCountrys?lang=${data}`,
      method: 'GET',
    });
  },

  // 登录前获取mfa信息
  async checkBeforeLogin(data) {
    const userName = (data.userName && data.userName.toLowerCase()) || '';
    const password = await encryptString(data.password);
    return request({
      url: `${serverUrl}/visa/latam/login/checkBeforeLoginV2`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: { ...data, userName, password },
    });
  },

  // 删除账号前 校验用户输入密码
  async verifyUserPassword(data) {
    const encryptPw = await encryptString(data.encryptPw);
    return request({
      url: `${serverUrl}/visa/latam/user/verifyUserPassword`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        ...data,
        encryptPw,
      },
    });
  },

  // 删除账号前 校验用户是否存在已支付、未使用的订单信息
  checkUserOrder(data) {
    return request({
      url: `${serverUrl}/visa/latam/user/checkUserOrder`,
      method: 'POST',
      data,
    });
  },

  // 删除账号
  deleteUser(data) {
    return request({
      url: `${serverUrl}/visa/latam/user/deleteUserV2`,
      method: 'POST',
      data,
    });
  },

  // 获取 marketingConsent 弹窗提示
  getMarketingNotice(data) {
    // Extract userId and sessionId to put in form-data (body)
    const { userId, sessionId, ...params } = data;
    const formData = new FormData();
    if (userId) formData.append('userId', userId);
    if (sessionId) formData.append('sessionId', sessionId);

    return request({
      url: `${serverUrl}/visa/latam/web/home`,
      method: 'POST',
      params, // Other parameters in URL
      data: formData, // userId and sessionId in form-data
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // 点击 marketingConsent提示 maybe later按钮
  updateNotificationTime(data) {
    return request({
      url: `${serverUrl}/visa/latam/marketing/updateNotificationTime`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // 点击 marketingConsent提示 send me updates 按钮
  updatePrivacySetting(data) {
    return request({
      url: `${serverUrl}/visa/latam/user/updatePrivacySetting`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // 获取 privacy settings
  getPrivacySetting(data) {
    return request({
      url: `${serverUrl}/visa/latam/user/getPrivacySetting`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },
};

export default login;
